<template>
<footer class="footer mt-auto" :class="footerStyle">
	<div class="container-xl px-4">
		<div class="row">
			<div class="col-md-6 small">
				{{$t('footerprescription.name', [footerprescriptionparams])}}
			</div>
			<div class="col-md-6 text-md-right small">
				{{$t('footerprescription.policy')}}
				<!-- <router-link :to="{ name: 'privacy-policy'}">
					{{this.$t('footerprescription.policy')}}
				</router-link> -->
				&middot;
				{{$t('footerprescription.termCondition')}}
				<!-- <router-link :to="{ name: 'terms-conditions'}">
					{{this.$t('footerprescription.termCondition')}}
				</router-link> -->
				&middot;
				<i>{{ appVersion }}</i>
			</div>
		</div>
	</div>
</footer>
</template>

<script>
export default {
	name: 'Footer',
	props: {
		footerStyle: {
			type: String,
			default: 'footer-light'
		}
	},
	data() {
		return {}
	},
	computed: {
		appVersion () {
			return 'altis-00001'
			// return `${"(env: " + this.$store.getters.appBuildEnv + ", version : " + this.$store.getters.appVersion + ", build : " + this.$moment(this.$store.getters.appBuildDate, "x").format('DD-MM-YYYY HH:mm') + ")"}`
		},
		footerprescriptionparams () {
			return '2016 - ' +(this.$moment(new Date(), "x").format('YYYY'))+ ' '+ process.env.VUE_APP_APP_NAME +'  | by TIGANA Alassane'
		}
	}

}
</script>